// pricing/index.ts
import top from "./top.jpg";

const Pricing = {
  top,
};

export default Pricing;

// 個別エクスポート
export { top as pricingTop };
